import { ANALYTICS_ACTION } from '../../../../modules/footer/footer.constants';
import { structure } from 'modules/footer';
import { TEXT_KEYS } from './fr-footer.constants';
import { IFooterLink } from 'modules/footer/footer.types';

export const links: IFooterLink[] = [
    ...structure.linksList,
    {
        key: TEXT_KEYS.FOOTER_TERMS_AND_CONDITIONS,
        href: 'https://legal.ubi.com/TermsandConditionsReferralProgram',
        analyticsAction: ANALYTICS_ACTION.TERMS_AND_CONDITIONS
    }
];
